import React, { useState, useRef } from "react";
import { Link, Navigate, Location, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { useMount, useUnmount } from "react-use";
import { useStores } from "../hooks";
import {
  login,
  loginPrivate,
  openLED,
  openReader,
  closeReader,
} from "../service";
import Keyboard, { KeyboardReactInterface } from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import Header from "../component/Header";
import CountDown from "../component/CountDown";
import Footer from "../component/Footer";

type LocationProp = {
  from: Location;
};

const Login = () => {
  const location = useLocation();
  const { from } = location.state as LocationProp;
  const { formatMessage } = useIntl();
  const { sessionStore } = useStores();
  const keyboardRef = useRef<null | KeyboardReactInterface>(null);
  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [inputName, setInputName] = useState("username");
  const [layoutName, setLayoutName] = useState("default");
  const [isLoginBox, setIsLoginBox] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [readerProcess, setReaderProcess] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [loginProcess, setLoginProcess] = useState(false);
  const [complete, setComplate] = useState(false);

  useMount(() => {
    sessionStore.privateHandler = handlePrivateLogin;
    handleReader();
  });

  useUnmount(() => {
    sessionStore.privateHandler = console.info;
    handleReaderClose();
  });

  const handleLoginBox = () => {
    setIsLoginBox(!isLoginBox);
  };

  const handleReader = () => {
    setReaderProcess(true);
    openReader(
      (cardNo: string) => {
        setReaderProcess(false);
        console.info("CardNo:" + cardNo);
        if (cardNo !== "") {
          handlePrivateLogin(cardNo);
        }
      },
      () => {
        // 如果無法呼叫讀卡機 應該就不需要關閉
        setReaderProcess(false);
      }
    );
  };

  const handleReaderClose = () => {
    if (readerProcess) {
      closeReader();
    }
  };

  const handleLogin = () => {
    setLoginProcess(true);
    const username = usernameRef.current!.value;
    const password = passwordRef.current!.value;
    login({ code: username, pass: password })
      .then((res) => {
        if (res !== undefined && res.success) {
          sessionStore.isAdmin = res.is_admin;
          sessionStore.isLogin = true;
          if (res.reader) {
            sessionStore.userInfo = res.reader;
          }
          if (!sessionStore.debug) {
            openLED();
          }
          setComplate(true);
        } else {
          console.error(res.message);
          setLoginMessage(res.message);
          setLoginError(true);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoginMessage(error);
        setLoginError(true);
      })
      .finally(() => {
        setLoginProcess(false);
      });
  };

  const handlePrivateLogin = (barcode: string) => {
    console.info("Barcode:" + barcode);
    loginPrivate({ code: barcode }).then((res) => {
      if (res.success) {
        sessionStore.isAdmin = res.is_admin;
        sessionStore.isLogin = true;
        if (res.reader) {
          sessionStore.userInfo = res.reader;
        }
        if (!sessionStore.debug) {
          openLED();
        }
        setComplate(true);
      } else {
        setLoginMessage(res.message);
        setLoginError(true);
      }
    });
  };

  return (
    <>
      {complete ? (
        <Navigate to={from} />
      ) : (
        <>
          <div
            className="overlay"
            style={{ display: loginError ? "block" : "none" }}
          >
            <div className="info">
              <section className="error">
                <p>{formatMessage({ id: "hyvendor.error.login" })}</p>
              </section>
              <div className="btns">
                <button
                  type="button"
                  className="btn confirm"
                  onClick={(e) => {
                    setLoginError(false);
                  }}
                >
                  {formatMessage({ id: "hyvendor.button.ok" })}
                </button>
                &nbsp;
                <Link to="/logout">
                  <button type="button" className="btn cancel">
                    {formatMessage({ id: "hyvendor.button.cancel" })}
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="page-set">
            <Header />
            <div className="Main gologin">
              <h3 className="Title">
                {formatMessage({ id: "hyvendor.title.login" })}
              </h3>
              <CountDown />
              <p>{formatMessage({ id: "hyvendor.message.logininfo" })}</p>
              <section className="sample">
                <img src={formatMessage({ id: "hyvendor.img.login" })} alt="" />
              </section>
              <section className="keyin">
                <p>{formatMessage({ id: "hyvendor.message.forgotcard" })}</p>
                <button
                  type="button"
                  className="btn switch"
                  onClick={handleLoginBox}
                >
                  {formatMessage({ id: "hyvendor.button.usekeyinlogin" })}
                </button>
                <div
                  className="box"
                  style={{ display: isLoginBox ? "block" : "none" }}
                >
                  <form action="" className="">
                    <div className="form_grp">
                      <input
                        name="username"
                        type="text"
                        placeholder={formatMessage({
                          id: "hyvendor.placeholder.username",
                        })}
                        ref={usernameRef}
                        onFocus={() => {
                          setInputName("username");
                          keyboardRef.current!.setInput(
                            usernameRef.current!.value
                          );
                        }}
                      />
                    </div>
                    <div className="form_grp">
                      <input
                        name="password"
                        type="password"
                        placeholder={formatMessage({
                          id: "hyvendor.placeholder.password",
                        })}
                        ref={passwordRef}
                        onFocus={() => {
                          setInputName("password");
                          keyboardRef.current!.setInput(
                            passwordRef.current!.value
                          );
                        }}
                      />
                    </div>
                    <div>
                      <Keyboard
                        layoutName={layoutName}
                        keyboardRef={(r) => (keyboardRef.current = r)}
                        onChange={(input) => {
                          if (inputName === "username") {
                            usernameRef.current!.value = input;
                          } else if (inputName === "password") {
                            passwordRef.current!.value = input;
                          }
                        }}
                        disableCaretPositioning={true}
                        onKeyPress={(button: any) => {
                          if (button === "{shift}" || button === "{lock}")
                            setLayoutName(
                              layoutName === "default" ? "shift" : "default"
                            );
                        }}
                      />
                    </div>
                    <div className="erorr">{loginMessage}</div>
                    <div className="btns">
                      <button
                        type="button"
                        className="btn next"
                        onClick={handleLogin}
                        disabled={loginProcess}
                      >
                        {formatMessage({ id: "hyvendor.button.next" })}
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        className="btn cancel"
                        onClick={(e) => {
                          e.preventDefault();
                          usernameRef.current!.value = "";
                          passwordRef.current!.value = "";
                          keyboardRef.current!.clearInput();
                        }}
                      >
                        {formatMessage({ id: "hyvendor.button.reset" })}
                      </button>
                    </div>
                  </form>
                </div>
              </section>
              <div className="btns">
                <Link to="/logout">
                  <button type="button" className="btn cancel">
                    {formatMessage({ id: "hyvendor.button.cancelexit" })}
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default Login;
